import * as Sentry from "@sentry/vue";

const AXEPTIO_CONFIG_ENDPOINT = 'https://client.axept.io/projectconfigurations/brands';

/**
 * Looks up the tenant's own Axeptio project configuration and returns the
 * `cookiesVersion` (banner identifier) whose `language` matches the site's
 * currently selected language. Returns undefined (no override) when no
 * language is given, no matching banner exists, or the lookup fails for any
 * reason — callers should fall back to Axeptio's own selection (geolocation).
 */
async function resolveCookiesVersion(clientId, language) {
	if (!language) {
		return undefined;
	}

	try {
		const response = await fetch(`${AXEPTIO_CONFIG_ENDPOINT}/${clientId}.json`);

		if (!response.ok) {
			return undefined;
		}

		const config = await response.json();
		const matchingBanner = (config.cookies || []).find((banner) => banner.language === language);

		return matchingBanner ? matchingBanner.name : undefined;
	} catch (error) {
		// Non-fatal: fall back to Axeptio's own selection (geolocation) below.
		Sentry.captureException(error);

		return undefined;
	}
}

export default {
	inject: async (options, onError) => {
		const cookiesVersion = await resolveCookiesVersion(options.clientId, options.language);

		// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
		// @ts-ignore
		window.axeptioSettings = {
			clientId: options.clientId,
			useDocumentLang: true,
			...(cookiesVersion ? { cookiesVersion } : {}),
			googleConsentMode: {
				default: {
					analytics_storage: 'denied',
					ad_storage: 'denied',
					ad_user_data: 'denied',
					ad_personalization: 'denied',
					wait_for_update: 500,
				},
			},
		};

		const script = document.createElement('script');
		script.setAttribute('type', 'text/javascript');
		script.setAttribute('src', '//static.axept.io/sdk.js');
		script.async = true;
		script.onerror = (event) => {
			if (typeof onError === 'function') {
				onError(event);
			}
		};

		document.getElementsByTagName('head')[0].appendChild(script);
	},
}
